import { render, staticRenderFns } from "./RequestServiceComponent.vue?vue&type=template&id=056fbeea&scoped=true&"
import script from "./RequestServiceComponent.vue?vue&type=script&lang=js&"
export * from "./RequestServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./RequestServiceComponent.vue?vue&type=style&index=0&id=056fbeea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fbeea",
  null
  
)

export default component.exports